<db-dialog-wrapper [dialog]="this" [width]="'500px'" [animateShow]="false">
  <div class="db-already-have-account-dialog">
    <div class="db-already-have-account-dialog-header" [innerHTML]="'text_alreadyHaveAccountTitle' | dbText"></div>
    <div class="db-already-have-account-dialog-message" [innerHTML]="'text_alreadyHaveAccountMessage' | dbText"></div>
    <div class="db-already-have-account-dialog-button">
      <a class="db-button db-button_info" (click)="close()"><span>{{'text_gotIt' | dbText}}</span></a>
    </div>
  </div>
</db-dialog-wrapper>
